// import {  getIdToken } from "firebase/auth";
import firebase from "../config/firebase"

export const getIdTokens = async () => {
  // const auth = getAuth();
  let idToken = "";
  idToken = await firebase.auth().currentUser?.getIdToken(true)
  return idToken;
};

export const validateURL=(str)=> {
  var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
  return !!pattern.test(str);
}